// extracted by mini-css-extract-plugin
module.exports = {"codeContainer":"styles_codeContainer__vsiBt","code":"styles_code__wltEs","copyButton":"styles_copyButton__1yY0c","light":"styles_light__ImlN3","dark":"styles_dark__aPrN9"};